module.exports = __webpack_public_path__ + "5f1a7ce4a577fb89e81fa5ce80a334c4.MP3";